/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import IssuesTable from '../../components/customTables/tasks/issuesTable';
import SearchHeader from '../../components/searchHeader';

/**
 * Style Imports
 */
import { TaskContainer } from './styles/Support.styles';

interface IssuesPageProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const SupportIssues: FC<IssuesPageProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <TaskContainer data-testid="support-issues-view">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <IssuesTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default SupportIssues;
